import { useLayoutStore } from '../../store/useLayoutStore';
import { cn } from '../../lib/cn';
import { SidebarLogo } from './SidebarLogo';
import { SidebarNav } from './SidebarNav';
import { SidebarUserCard } from './SidebarUserCard';
import { SidebarCollapseButton } from './SidebarCollapseButton';

export function Sidebar() {
  const sidebarCollapsed = useLayoutStore((s) => s.sidebarCollapsed);

  return (
    <aside
      className={cn(
        'cime-sidebar-scroll flex flex-col h-screen sticky top-0 bg-[linear-gradient(180deg,var(--cime-sidebar-bg)_0%,var(--cime-sidebar-bg-deep)_100%)] border-r border-cime-sidebar-border',
        'transition-[width] duration-200 ease-in-out overflow-x-hidden overflow-y-auto flex-shrink-0 print:hidden',
        sidebarCollapsed ? 'w-[72px]' : 'w-[270px]',
      )}
    >
      {/* Logo */}
      <div className="flex-shrink-0 border-b border-cime-sidebar-border">
        <SidebarLogo collapsed={sidebarCollapsed} />
      </div>

      {/* Navigation */}
      <SidebarNav collapsed={sidebarCollapsed} />

      {/* Bottom section */}
      <div className="flex-shrink-0 mt-auto border-t border-cime-sidebar-border">
        <SidebarUserCard collapsed={sidebarCollapsed} />
        <SidebarCollapseButton />
      </div>
    </aside>
  );
}
